import React, { FC, useEffect } from "react"
import { Form, Modal, Switch } from "antd"
import { observer } from "mobx-react"

import { useStore } from "stores/utils/use-store"
import { SubmitCancelButtons } from "components"

export const DepthCapture: FC<{
  visible: boolean;
  onClose: () => void;
}> = observer(({ visible, onClose }) => {
  const [form] = Form.useForm<{ enabled: boolean }>()

  const { dataStore: { accountDetailsStore } } = useStore()

  const currentEnabled = !!accountDetailsStore.account.depthCapture

  // Reflect the account's current flag every time the modal opens so a no-op
  // submit can't silently overwrite a true state with false.
  useEffect(() => {
    if (visible) form.setFieldsValue({ enabled: currentEnabled })
  }, [visible, currentEnabled, form])

  const onFinishHandler = async(e: { enabled: boolean }) => {
    accountDetailsStore.funcAfterSuccess = async() => {
      onClose()
      form.resetFields()
      await accountDetailsStore.getAccountDetails(accountDetailsStore.id)
    }
    await accountDetailsStore.setDepthCapture(e.enabled)
  }

  return (
    <Modal visible={visible} title="Depth Capture" footer={null} onCancel={() => onClose()}>
      <Form form={form} onFinish={onFinishHandler}>
        <div style={{ marginBottom: "10px" }}>
          Installs ReShade and the depth add-on into this account&apos;s depth games and records their depth.
          Needs Depth capture enabled in Recording Config and the account opted in to recording.
          Never flag an account on a shared or customer PC.
        </div>
        <Form.Item label="Depth capture" name="enabled" valuePropName="checked" initialValue={currentEnabled}>
          <Switch />
        </Form.Item>
        <SubmitCancelButtons onClose={onClose} isLoading={accountDetailsStore.isLoading} />
      </Form>
    </Modal>
  )
})
